import { useNegotiation } from '@context/negotiation.context';
import Button from '@components/atoms/button/button';
import React, { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import useHeroPdpStyles from '@hooks/hero-pdp/use-hero-pdp-styles';
import useUser from '@hooks/user/use-user';
import useFeatureFlag from '@hooks/use-feature-flags';
import AuthenticationGuard from '@components/atoms/authentication/authentication-guard/authentication-guard';
import styles from '../CTA-product.module.scss';

export type OfferButtonProps = {
  onClick: () => void;
  className?: string;
  openFromAuthModal?: boolean;
  shouldDisplayAsLink?: boolean;
  setOpenNegotiationFromAuthModal: (value: boolean) => void;
};

const OfferButton: React.FC<OfferButtonProps> = ({
  onClick,
  openFromAuthModal,
  setOpenNegotiationFromAuthModal,
  className,
}) => {
  const { t } = useTranslation();
  const { isAuthenticated } = useUser();
  const { initialData, negotiation } = useNegotiation();
  const { isHeroPdpStyles } = useHeroPdpStyles();
  const isDisabled = !isAuthenticated ? false : !Boolean(initialData) || Boolean(negotiation);
  const { isSemPDP } = useFeatureFlag();
  const buttonSize = isHeroPdpStyles && !isSemPDP ? 'medium' : 'large';

  useEffect(() => {
    setOpenNegotiationFromAuthModal(false);
  }, [setOpenNegotiationFromAuthModal]);

  useEffect(() => {
    if (initialData && openFromAuthModal) {
      onClick();
    }
  }, [initialData, openFromAuthModal, onClick]);

  return (
    <AuthenticationGuard
      className={clsx(styles.CTAButtonsBlock__authGuardWrapper, styles['CTAButtonsBlock__authGuardWrapper--MMAO'])}
      onAuth={() => {
        setOpenNegotiationFromAuthModal(true);
      }}
    >
      <Button
        disabled={isDisabled}
        onClick={onClick}
        variant="secondary"
        size={buttonSize}
        fullWidth={true}
        data-cy="pdp_mmao_btn"
        data-vc-dd-action-name="pdp_mmao_button"
        className={clsx(
          styles.CTAButtonsBlock__button,
          styles['CTAButtonsBlock__button--MMAO'],
          isHeroPdpStyles ? 'vc-btn--large--md-up' : '',
          className,
        )}
      >
        {t('PRODUCT.DETAILS.CTA.NEGOCIATE')}
      </Button>
    </AuthenticationGuard>
  );
};

export default OfferButton;
